var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1253 1.21094H4.83366C3.50449 1.21094 2.41699 2.29844 2.41699 3.6276V19.3359C2.41699 20.0005 2.96074 20.5443 3.62533 20.5443C4.28991 20.5443 4.83366 20.0005 4.83366 19.3359V4.83594C4.83366 4.17135 5.37741 3.6276 6.04199 3.6276H18.1253C18.7899 3.6276 19.3337 3.08385 19.3337 2.41927C19.3337 1.75469 18.7899 1.21094 18.1253 1.21094ZM18.8382 6.75719L24.6745 12.5934C25.1216 13.0405 25.3753 13.6568 25.3753 14.2972V25.3776C25.3753 26.7068 24.2878 27.7943 22.9587 27.7943H9.65491C8.32574 27.7943 7.25033 26.7068 7.25033 25.3776L7.26241 8.46094C7.26241 7.13177 8.33783 6.04427 9.66699 6.04427H17.1224C17.7628 6.04427 18.3791 6.29802 18.8382 6.75719ZM18.1253 14.5026H23.5628L16.917 7.85677V13.2943C16.917 13.9589 17.4607 14.5026 18.1253 14.5026Z",
    fill: "#A5D4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.1eaf6fc41d05d0bb7ced47fb7043a65c.svg";
export { ForwardRef as ReactComponent };